import { render, staticRenderFns } from "./PresenceModalForm.vue?vue&type=template&id=5c209bda&scoped=true&"
import script from "./PresenceModalForm.vue?vue&type=script&lang=js&"
export * from "./PresenceModalForm.vue?vue&type=script&lang=js&"
import style0 from "./PresenceModalForm.vue?vue&type=style&index=0&id=5c209bda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c209bda",
  null
  
)

export default component.exports